module.exports = __webpack_public_path__ + "fonts/ubuntu-ruble-medium.ed97b10.woff";